module.exports = __webpack_public_path__ + "static/measuring-success-1a2f63f4742e31f78f3a49047c3b5ede.png";